import { v4 as uuidv4 } from 'uuid';

export function generateSdkId(): string {
  return uuidv4();
}
